module.exports = __webpack_public_path__ + "img/wechart.7ad41f97.png";